import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { useHTTP } from 'hooks/useRequest';
import toRem from 'utils/toRem';

import { white } from 'constants/variables';

const AccountChangeRequestModal = ({
  modalIsOpen,
  closeModal,
  accountDeletionData,
}) => {
  const [hasBeenConfirmed, setHasBeenComfirmed] = useState(false);

  const accountDeletionRequestConfig = {
    method: 'POST',
    url: hasBeenConfirmed
      ? '/mycef/account_change_request/send_request.json'
      : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: accountDeletionData,
  };

  const { data: accountDeletionResponse, loading } = useHTTP(
    accountDeletionRequestConfig || null,
  );

  useEffect(() => {
    setHasBeenComfirmed(false);
    if (accountDeletionResponse?.success) {
      window.location.href = '/mycef/account/edit';
    }
  }, [accountDeletionResponse]);

  return (
    <StyledModal isOpen={modalIsOpen} closeModal={closeModal}>
      <p className="ff-body fs-20 tc-grey-70 fw-600 lh-1-3">
        Are you sure you want to request permanent deletion of your trade
        account?
      </p>
      <div className="confirmation-modal__buttons fl jc-fe mt-40">
        <ConfirmationModalButton
          type="button"
          handleClick={closeModal}
          label="Cancel"
          className="cef-btn cef-btn--grey cef-btn--feature cef-ui__button">
          Cancel
        </ConfirmationModalButton>
        <ConfirmationModalButton
          type="button"
          handleClick={() => setHasBeenComfirmed(true)}
          label="Send Request"
          className="cef-btn cef-btn--red cef-btn--feature cef-ui__button ml-16">
          {!loading ? <>Send Request</> : <LoadingSpinner className="loader" />}
        </ConfirmationModalButton>
      </div>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  > div {
    padding: 2rem 1.875rem;
    width: 70%;
    max-width: 475px;
  }
`;

const LoadingSpinner = styled.div`
  border-top: ${toRem(6)} solid rgba(255, 255, 255, 0.2);
  border-right: ${toRem(6)} solid rgba(255, 255, 255, 0.2);
  border-bottom: ${toRem(6)} solid rgba(255, 255, 255, 0.2);
  border-left: ${toRem(6)} solid ${white};
  margin-bottom: 0;
  width: 12px;
  height: 12px;
`;

const ConfirmationModalButton = styled(Button)`
  width: 50%;
  max-width: 160px;
  white-space: nowrap;
`;

export default AccountChangeRequestModal;
